import logo from './logo.svg';
import './App.css';
import Button from '@mui/material/Button';
import { ButtonGroup, Paper } from '@mui/material';
import { AboutMeCard } from './AboutMeCard';
import NameHeader from './NameHeader';
import ResumeSection from './ResumeSection';
import Resume from './Resume';

function Home() {
  return (
    <div style={{ height: '20em'}}>
      {/* <NameHeader /> */}
      {/* <ResumeSection /> */}
      <Resume />
      {/* <AboutMeCard /> */}
    </div>
  );
}

export default Home;
